<template>
  <div class="active-wrap container" @click="toMore">
    <titleConfig
      :title="langSet == 'cn' ? '活动' : 'Events'"
      :type="1"
    ></titleConfig>
    <div class="active-text" v-if="langSet == 'cn'">
      API
      China作为制药工业领域的“风向标”平台，是制药企业与药品研发至生产各个环节中的供应链企业、医药研发与生产服务类企业、贸易经销商沟通交流的重要桥梁。API
      China将“提升参展实效性，提高参会服务体验”作为要务，简约、直接的呈现方式在展会现场举办新品发布、商贸对接、定制参观等多主题、多形式、多内容的展期活动，帮助参展商企业高效对接现场观众，更精准的满足参展商与观众的商贸需求，发掘新商业机会，保证参展企品牌及产品的持续性露出，提升推广热度，满足不同企业品牌的多样参展需求。
    </div>
    <div class="active-text active-text-en" v-else>
      As a ”barometer” platform in the pharmaceutical industry, API China is an
      important bridge for communication between pharmaceutical enterprises and
      supply chain companies, pharmaceutical R&D and production service
      companies, and trade distributors. With the mission to enhance the
      effectiveness of the exhibition and optimize the participants' experience,
      API China presents, through a simple and direct method, a series of
      multi-themed, multi-format, and multi-content on site activities. These
      include new product launches, business matchmaking sessions, and
      customized visits. These events help exhibitors to engage efficiently with
      professional attendees, meet precise business demands, explore new market
      opportunities, ensure the continuous exposure of their brands and
      products, boost promotional visibility, and meet the diverse needs of the
      different companies.
    </div>
    <div class="btn-slide flex_content_center flex_items_center">
      <div class="btn-main">
        <span class="icon"></span>{{ langSet == "cn" ? "查看详情" : "Details" }}
      </div>
    </div>
  </div>
</template>
<script>
import titleConfig from "@/components/title.vue";
import { sdkClick } from "../../../sdk/useSdk";
export default {
  components: {
    titleConfig,
  },
  data() {
    return {
      langSet: "",
    };
  },
  mounted() {
    this.langSet = this.$language;
  },
  methods: {
    toMore() {
      sdkClick("首页功能区", "会议活动>>现场活动");
      this.$router.push({
        path: "/liveEvents",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.active-wrap {
  height: auto;
  padding: 50px;
  box-sizing: border-box;
  margin-bottom: 120px;
  background: url("../../../assets/imgs/active_bg.jpg") no-repeat;
  background-size: 100% 100%;
  .active-text {
    width: 65%;
    font-size: 23px;
    color: #001a33;
    line-height: 38px;
    margin: 10px 0;
  }
  .active-text-en {
    font-size: 19px;
    line-height: 32px;
  }
}

@media only screen and (max-width: 1280px) {
  .active-wrap {
    padding: 45px;
    .active-text {
      width: 68%;
      font-size: 20px;
      line-height: 35px;
    }
    .active-text-en {
      font-size: 17px;
      line-height: 32px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .active-wrap {
    width: 6.73rem;
    padding: 0.58rem 0.38rem;
    margin-bottom: 0.9rem;
    .btn-slide {
      display: none;
    }
    .active-text {
      font-size: 0.29rem;
      line-height: 0.46rem;
      margin: 0.2rem 2.8rem 0 0;
    }
  }
}
</style>